import { metaWebViewFilter } from './filters/metaWebViewFilter';
import type { ErrorFilterConfig } from '@funnellab/shared/src/errorHandling/errorFilter';

export const errorFilters: ErrorFilterConfig[] = [
  {
    name: 'Meta WebView Java bridge errors',
    enabled: true,
    filter: metaWebViewFilter,
  },
];
